import * as React from "react";
import { Checkbox } from "antd";
import { observer } from "mobx-react-lite";
import { ZUid } from "src/types/zUid";
import { isChecked } from "src/common/groupChecked";
import { Bom2aEdPosition } from "../../Bom2aPositionsTypes";
import { Bom2aPositionsStore } from "../../Bom2aPositionsStore";

type PropsBom2aSelectionHdr = {
  store: Bom2aPositionsStore;
};

export const Bom2aSelectionHdr: React.FC<PropsBom2aSelectionHdr> = observer(
  ({ store }) => {
    const checked = store.totalSelection;
    return (
      <div style={{ textAlign: "center" }}>
        <Checkbox
          checked={isChecked(checked)}
          indeterminate={checked === "partial"}
          onChange={() => store.toggleTotal(checked)}
        />
      </div>
    );
  },
);

type PropsBom2aRowSelection = {
  material: Bom2aEdPosition;
  store: Bom2aPositionsStore;
};

export const Bom2aRowSelection: React.FC<PropsBom2aRowSelection> = observer(
  ({ material, store }) => {
    const checked = store.materialSelection(material);
    return (
      <div style={{ textAlign: "center" }}>
        <Checkbox
          checked={isChecked(checked)}
          indeterminate={checked === "partial"}
          onChange={() => store.toggleMaterial(material, checked)}
          disabled={material.bomPositionRows.length === 0}
        />
      </div>
    );
  },
);

type PropsBom2aPosSelection = {
  posId: ZUid;
  store: Bom2aPositionsStore;
};

export const Bom2aPosSelection: React.FC<PropsBom2aPosSelection> = observer(
  ({ posId, store }) => (
    <div style={{ textAlign: "center" }}>
      <Checkbox
        checked={store.selectedIds.has(posId)}
        onChange={() => store.togglePositionRow(posId)}
      />
    </div>
  ),
);
